export default "__VITE_ASSET__C62H$PPd__"